(function () {
  if (window.__amCopyLinkInit) return;
  window.__amCopyLinkInit = true;

  var clearTimers = new WeakMap();

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    return new Promise(function (resolve, reject) {
      var input = document.createElement('textarea');
      input.value = text;
      input.setAttribute('readonly', '');
      input.style.position = 'absolute';
      input.style.left = '-9999px';
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        resolve();
      } catch (err) {
        reject(err);
      } finally {
        document.body.removeChild(input);
      }
    });
  }

  function getStatusEl(btn) {
    var container = btn.closest('.share-icons__container');
    if (container) {
      return container.querySelector('[data-am-copy-link-status]');
    }
    return btn.querySelector('.share-icons__copy-link-status');
  }

  function showStatus(status, message, isError) {
    if (!status) return;
    var prev = clearTimers.get(status);
    if (prev) window.clearTimeout(prev);

    status.textContent = message;
    status.classList.toggle('is-error', !!isError);
    status.classList.add('is-visible');

    var timer = window.setTimeout(function () {
      status.classList.remove('is-visible', 'is-error');
      status.textContent = '';
      clearTimers.delete(status);
    }, 2200);
    clearTimers.set(status, timer);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-am-copy-link]');
    if (!btn) return;

    event.preventDefault();
    var url = btn.getAttribute('data-am-copy-link') || window.location.href;
    var status = getStatusEl(btn);

    copyText(url)
      .then(function () {
        btn.classList.add('is-copied');
        showStatus(status, 'Link copied', false);
        window.setTimeout(function () {
          btn.classList.remove('is-copied');
        }, 2200);
      })
      .catch(function () {
        showStatus(status, 'Unable to copy', true);
      });
  });
})();
